<template>
  <div style="height:100vh; display: flex; flex-direction: row;   justify-content: center;
  justify-items: center;
  align-items: center;
">
    <img alt="Vue logo" src="../assets/logo.png">
  </div>
</template>

<script>
import macesso from '@/dados/macesso';

export default {
  name: 'PaginaInicial',
  components: {
  },
  mounted(){

    macesso.recuperarCaminho().then(()=>{
      let r = macesso.retorno;
      window.location.href = r;
    });

  },

}
</script>
